import type React from "react";
import { ReactComponent as Svg } from "./assets/withdrawal.svg";
import * as styles from "./Icon.module.scss";

type WithdrawalProps = React.SVGProps<SVGSVGElement>;

export const Withdrawal = ({ className, ...props }: WithdrawalProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
